import { ERROR_RESET } from 'Constants/actionTypes';

export const errorReset = (type) => ({
	type: ERROR_RESET,
	payload: type
});